import { useMemo } from 'react';

import { ScanDataInMemory } from '@kaiizen/kai-scan-template-system';

import { useAuth } from '../../../useAuth';

import { SyncRecordBase, useSyncModel } from '../persistence';

export interface ScanDataSyncRecord extends SyncRecordBase {
  scanData: ScanDataInMemory;
}

export const useScanDataSyncModel = () => {
  const { userId } = useAuth();
  const model = useSyncModel<ScanDataSyncRecord>('scanData');

  return useMemo(() => ({
    ...model,
    addScanDataToSync: async (scanId: string, scanDataArray: ScanDataInMemory[]) => {
      if (!userId) throw new Error('userId required');
      await Promise.all(scanDataArray.map(scanData =>
        model.put({
          _id: scanData.id,
          userId,
          scanId,
          scanData,
          isSynced: false,
          isSyncing: false,
          isFailed: false,
        }).catch(error => {
          console.error('Failed to add scan data to sync', error, { userId, scanId, scanDataArray });
        })
      ));
    },
  }), [model, userId]);
};
